import angular from "angular";
import watcherCounterService from "./services/sb_watcher_counter.service";
import watcherCounterDirective from "./directives/sb_watcher_counter.directive";

export default angular
    .module("sbApp.sbWatcherCounter", [])
    .factory("$sbAngularWatcher", watcherCounterService)
    .directive("sbWatcherCounter", watcherCounterDirective);
